import { useState } from "react";
import { addNote, type UserNote } from "@/api/adminApi";

function formatDateTime(d: string): string {
  return new Date(d).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric",
    hour: "numeric", minute: "2-digit",
  });
}

interface NoteSectionProps {
  userId: string;
  notes: UserNote[];
  onNoteAdded: () => void;
}

export function NoteSection({ userId, notes, onNoteAdded }: NoteSectionProps) {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const handleAdd = async () => {
    if (!text.trim()) return;
    setSaving(true);
    try {
      await addNote(userId, text.trim());
      setText("");
      onNoteAdded();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <h3 className="section-title">Support Notes</h3>
      <div className="card" style={{ padding: 16 }}>
        <div style={{ display: "flex", gap: 8, marginBottom: notes.length > 0 ? 12 : 0 }}>
          <textarea
            className="input-field"
            placeholder="Add a note..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={2}
            style={{ flex: 1 }}
          />
          <button
            className="btn-gold"
            onClick={handleAdd}
            disabled={saving || !text.trim()}
            style={{ alignSelf: "flex-end" }}
          >
            {saving ? "..." : "Add"}
          </button>
        </div>
        {notes.map((n) => (
          <div key={n.id} className="note-item">
            <div className="note-text">{n.note}</div>
            <div className="note-meta">{formatDateTime(n.created_at)}</div>
          </div>
        ))}
      </div>
    </>
  );
}
